import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Organization name */
  organizationName: string;
  /** Role/title within the organization (optional) */
  role?: string;
  /** Test ID */
  "data-testid"?: string;
};

/**
 * Single affiliation item showing organization name and role.
 */
export function ProfileAffiliationItem({
  organizationName,
  role,
  "data-testid": testId,
}: Props) {
  return (
    <div className="flex flex-col gap-1" data-testid={testId}>
      <Type variant="h6">
        {organizationName}
      </Type>
      {role && <Type variant="caption">{role}</Type>}
    </div>
  );
}

export default ProfileAffiliationItem;
